import { UploadData } from '../../../../../../store/uploadStore';
import { classes, stylesheet } from 'typestyle';
import { Gray140, Gray20, typeCompact12MediumProperties, typeCompact14MediumProperties } from '@traceair/tds';
import { FlightValidationProgressBar } from './FlightValidationProgressBar';
import { getUploadValidationCount, getUploadValidationStatus } from '../../../helpers/uploadValidation';
import { FlightValidationIssueList } from './FlightValidationIssueList';
import { ProjectData } from '../../../types';

const css = stylesheet({
  container: {
    padding: '15px 13px 15px 13px',
    marginBottom: 6,
    borderRadius: 12,
    border: `1px solid ${Gray20}`,
    boxShadow: '0 1px 2px rgba(16, 24, 41, 0.05)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    ...typeCompact14MediumProperties,
  },
  count: {
    color: Gray140,
    ...typeCompact12MediumProperties,
  },
});

interface Props extends ProjectData {
  upload: UploadData | undefined;
}

export const FlightUploadQuality = ({ customer, site, upload }: Props) => {
  if (!upload) {
    return null;
  }

  const count = getUploadValidationCount(upload);
  const status = getUploadValidationStatus(upload, count);

  const all = upload.overview.photosCount.all;
  const progress = (count / all) * 100;

  const isFinished = count === all;

  return (
    <div className={css.container}>
      <header className={css.header}>
        <div className={classes(css.title)}>{isFinished ? 'Quality checked' : 'Checking quality'}</div>
        <div className={css.count}>{isFinished ? `${all} files` : `${count} of ${all} files`}</div>
      </header>

      <FlightValidationProgressBar progress={progress} status={status} />

      <FlightValidationIssueList customer={customer} site={site} upload={upload} />
    </div>
  );
};
